import axios from 'axios';
import {toastr} from 'react-redux-toastr';

export const FETCH_CAMPAIGNS              = 'FETCH_CAMPAIGNS';
export const CREATE_CAMPAIGN              = 'CREATE_CAMPAIGNS';
export const FETCH_CAMPAIGN               = 'FETCH_CAMPAIGN';
export const DELETE_CAMPAIGN              = 'DELETE_CAMPAIGN';
export const DUPLICATE_CAMPAIGN           = 'DUPLICATE_CAMPAIGN';
export const DUPLICATE_CAMPAIGN_FROM_STARTER = 'DUPLICATE_CAMPAIGN_FROM_STARTER';
export const UPDATE_CAMPAIGN              = 'UPDATE_CAMPAIGN';
export const UPDATE_CAMPAIGN_FILTERS      = 'UPDATE_CAMPAIGN_FILTERS';
export const UPDATE_CAMPAIGN_AUTO_STOP    = 'UPDATE_CAMPAIGN_AUTO_STOP';
export const PUBLISH_CAMPAIGN             = 'PUBLISH_CAMPAIGN';
export const EDIT_CAMPAIGN                = 'EDIT_CAMPAIGN';
export const FETCH_CAMPAIGN_EMAILS        = 'FETCH_CAMPAIGN_EMAILS';
export const FETCH_CAMPAIGN_SMS           = 'FETCH_CAMPAIGN_SMS';
export const FETCH_CAMPAIGN_POSTCARDS     = 'FETCH_CAMPAIGN_POSTCARDS';
export const FETCH_CAMPAIGN_SUBSCRIPTIONS = 'FETCH_CAMPAIGN_SUBSCRIPTIONS';
export const FETCH_CAMPAIGN_RVMS          = 'FETCH_CAMPAIGN_RVMS';

export const FETCH_TEMPLATES              = 'FETCH_TEMPLATES';
export const CREATE_TEMPLATE              = 'CREATE_TEMPLATE';
export const FETCH_TEMPLATE               = 'FETCH_TEMPLATE';
export const DELETE_TEMPLATE              = 'DELETE_TEMPLATE';
export const UPDATE_TEMPLATE              = 'UPDATE_TEMPLATE';
export const DUPLICATE_TEMPLATE           = 'DUPLICATE_TEMPLATE';

export const FETCH_EMAIL_BROADCASTS       = 'FETCH_EMAIL_BROADCASTS';
export const FETCH_EMAIL_BROADCAST_EMAILS = 'FETCH_EMAIL_BROADCAST_EMAILS';
export const CANCEL_EMAIL_BROADCAST       = 'CANCEL_EMAIL_BROADCAST';
export const FETCH_ALL_EMAIL_BROADCASTS   = 'FETCH_ALL_EMAIL_BROADCASTS';

export const CREATE_TEMPLATE_CATEGORY     = 'CREATE_TEMPLATE_CATEGORY';
export const EDIT_TEMPLATE_CATEGORY       = 'EDIT_TEMPLATE_CATEGORY';
export const FETCH_TEMPLATE_CATEGORIES    = 'FETCH_TEMPLATE_CATEGORIES';

export const FETCH_COMPANY                = 'FETCH_COMPANY';
export const FETCH_ROOKERY_STATUS_INFO    = 'FETCH_ROOKERY_STATUS_INFO';
export const POST_COMPANY_CONFIGURE       = 'POST_COMPANY_CONFIGURE';
export const FETCH_COMPANIES              = 'FETCH_COMPANIES';
export const FETCH_COMPANY_REGISTRAR      = 'FETCH_COMPANY_REGISTRAR';
export const ACCEPT_COMPANY_TOS           = 'ACCEPT_COMPANY_TOS';
export const ACCEPT_COMPANY_RVM_USAGE     = 'ACCEPT_COMPANY_RVM_USAGE';
export const CHANGE_COMPANY_IP            = 'CHANGE_COMPANY_IP';
export const ENABLE_COMPANY               = 'ENABLE_COMPANY';
export const DISABLE_COMPANY              = 'DISABLE_COMPANY';
export const POKE_COMPANY_LRR             = 'POKE_COMPANY_LRR';
export const POKE_COMPANY_DNS             = 'POKE_COMPANY_DNS';
export const UPDATE_COMPANY_OFFICE_HOURS  = 'UPDATE_COMPANY_OFFICE_HOURS';
export const UPDATE_COMPANY_GEEK_AI       = 'UPDATE_COMPANY_GEEK_AI';
export const CHANGE_COMPANY_DOMAIN        = 'CHANGE_COMPANY_DOMAIN';

export const CREATE_TEST_EMAIL            = 'CREATE_TEST_EMAIL';
export const CREATE_TEST_SMS              = 'CREATE_TEST_SMS';

export const GET_S3_FILEBROWSER_DIRECTORY = 'GET_S3_FILEBROWSER_DIRECTORY';
export const GET_S3_TOKENS                = 'GET_S3_TOKENS';

export const FETCH_SMS_TEMPLATES          = 'FETCH_SMS_TEMPLATES';
export const CREATE_SMS_TEMPLATE          = 'CREATE_SMS_TEMPLATE';
export const FETCH_SMS_TEMPLATE           = 'FETCH_SMS_TEMPLATE';
export const DELETE_SMS_TEMPLATE          = 'DELETE_SMS_TEMPLATE';
export const UPDATE_SMS_TEMPLATE          = 'UPDATE_SMS_TEMPLATE';
export const DUPLICATE_SMS_TEMPLATE       = 'DUPLICATE_SMS_TEMPLATE';

export const CREATE_SMS_TEMPLATE_CATEGORY = 'CREATE_SMS_TEMPLATE_CATEGORY';
export const EDIT_SMS_TEMPLATE_CATEGORY   = 'EDIT_SMS_TEMPLATE_CATEGORY';
export const FETCH_SMS_TEMPLATE_CATEGORIES= 'FETCH_SMS_TEMPLATE_CATEGORIES';

export const FETCH_ALL_STARTER_CAMPAIGNS     = 'FETCH_ALL_STARTER_CAMPAIGNS';
export const FETCH_ACTIVE_STARTER_CAMPAIGNS  = 'FETCH_ACTIVE_STARTER_CAMPAIGNS';
export const CREATE_STARTER_CAMPAIGN         = 'CREATE_STARTER_CAMPAIGNS';

export const FETCH_EMAIL_ADDRESSES           = 'FETCH_EMAIL_ADDRESSES';
export const MARK_EMAIL_ADDRESS_AS_VALID     = 'MARK_EMAIL_ADDRESS_AS_VALID';

export const FETCH_SENT_EMAILS               = 'FETCH_SENT_EMAILS';
export const FETCH_SENT_EMAIL                = 'FETCH_SENT_EMAIL';

export const REENGAGE_LEAD                   = 'REENGAGE_LEAD';

export const RESTART_SUBSCRIPTION            = 'RESTART_SUBSCRIPTION';

export const FETCH_RVM_TEMPLATES          = 'FETCH_RVM_TEMPLATES';
export const CREATE_RVM_TEMPLATE          = 'CREATE_RVM_TEMPLATE';
export const FETCH_RVM_TEMPLATE           = 'FETCH_RVM_TEMPLATE';
export const DELETE_RVM_TEMPLATE          = 'DELETE_RVM_TEMPLATE';
export const UPDATE_RVM_TEMPLATE          = 'UPDATE_RVM_TEMPLATE';
export const CREATE_TEST_RVM              = 'CREATE_TEST_RVM';

export const CREATE_RVM_TEMPLATE_CATEGORY = 'CREATE_RVM_TEMPLATE_CATEGORY';
export const EDIT_RVM_TEMPLATE_CATEGORY   = 'EDIT_RVM_TEMPLATE_CATEGORY';
export const FETCH_RVM_TEMPLATE_CATEGORIES= 'FETCH_RVM_TEMPLATE_CATEGORIES';

export const FETCH_VIDEO_TEMPLATES          = 'FETCH_VIDEO_TEMPLATES';
export const CREATE_VIDEO_TEMPLATE          = 'CREATE_VIDEO_TEMPLATE';
export const FETCH_VIDEO_TEMPLATE           = 'FETCH_VIDEO_TEMPLATE';
export const DELETE_VIDEO_TEMPLATE          = 'DELETE_VIDEO_TEMPLATE';
export const UPDATE_VIDEO_TEMPLATE          = 'UPDATE_VIDEO_TEMPLATE';
export const FETCH_VIDEO_TEMPLATE_BY_NAME   = 'FETCH_VIDEO_TEMPLATE_BY_NAME';

export const CREATE_VIDEO_TEMPLATE_CATEGORY = 'CREATE_VIDEO_TEMPLATE_CATEGORY';
export const EDIT_VIDEO_TEMPLATE_CATEGORY   = 'EDIT_VIDEO_TEMPLATE_CATEGORY';
export const FETCH_VIDEO_TEMPLATE_CATEGORIES= 'FETCH_VIDEO_TEMPLATE_CATEGORIES';

export const FETCH_LEADS                    = 'FETCH_LEADS';
export const FETCH_LEAD_FILTER_LOGS         = 'FETCH_LEAD_FILTER_LOGS';

export const FETCH_REACTIVE_RESPONSE_SETTINGS = 'FETCH_REACTIVE_RESPONSE_SETTINGS';
export const EDIT_REACTIVE_RESPONSE_SETTINGS  = 'EDIT_REACTIVE_RESPONSE_SETTINGS';
export const EDIT_REACTIVE_RESPONSE_PRIORITIZE  = 'EDIT_REACTIVE_RESPONSE_PRIORITIZE';

const ROOT_URL = process.env.API_ROOT_URL;

// ==============================================
// Campaigns
// ==============================================

axios.defaults.withCredentials = true;

function processErrors(error) {
  if (error.response.status == 401 ||
    String(error.response) == "Error: Network Error" ||
    String(error.response.data) == "missing 'X-Site-UUID' header"
) {
    const ROOT_URL = process.env.API_ROOT_URL.replace("/v1","");
    // window.location = ROOT_URL + "/auth/realgeeks/?next=" + window.location;
    window.location = ROOT_URL + "/auth/realgeeks/";
  } else {
    toastr.error('Error', error.response.data.data[0]);
    return error;
  }
}

function getSiteUuid() {
  return localStorage.getItem('lastSiteUUID');
}

export function fetchCampaigns(query_string = '') {
  const request = axios.get( `${ROOT_URL}/campaigns${query_string}`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: FETCH_CAMPAIGNS,
    payload: request
  };
}

export function createCampaign(props) {
  const request = axios.post(`${ROOT_URL}/campaigns`, props, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: CREATE_CAMPAIGN,
    payload: request
  };
}

export function fetchCampaign(id) {
  const request = axios.get(`${ROOT_URL}/campaigns/${id}`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: FETCH_CAMPAIGN,
    payload: request
  };
}

export function deleteCampaign(id) {
  const request = axios.delete(`${ROOT_URL}/campaigns/${id}`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: DELETE_CAMPAIGN,
    payload: request
  };
}

export function duplicateCampaign(id, props) {
  const request = axios.post(`${ROOT_URL}/campaigns/${id}/duplicate`, props, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: DUPLICATE_CAMPAIGN,
    payload: request
  };
}

export function duplicateCampaignFromStarter(id, props) {
  const request = axios.post(`${ROOT_URL}/campaigns/${id}/duplicate_from_starter`, props, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: DUPLICATE_CAMPAIGN_FROM_STARTER,
    payload: request
  };
}

export function updateCampaign(id, props) {
  const request = axios.put(`${ROOT_URL}/campaigns/${id}`, props, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: UPDATE_CAMPAIGN,
    payload: request
  };
}

export function updateCampaignFilters(id, props) {
  const request = axios.put(`${ROOT_URL}/campaigns/${id}/update_filters`, props, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: UPDATE_CAMPAIGN_FILTERS,
    payload: request
  };
}

export function updateCampaignAutoStop(id, props) {
  const request = axios.put(`${ROOT_URL}/campaigns/${id}/update_auto_stop`, props, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: UPDATE_CAMPAIGN_AUTO_STOP,
    payload: request
  };
}

export function publishCampaign(id, props) {
  const request = axios.put(`${ROOT_URL}/campaigns/${id}/publish`, props, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: PUBLISH_CAMPAIGN,
    payload: request
  };
}

export function editCampaign(id, props) {
  const request = axios.post(`${ROOT_URL}/campaigns/${id}/create_draft`, props, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: EDIT_CAMPAIGN,
    payload: request
  };
}

export function fetchCampaignEmails(id, query_string = '') {
  const request = axios.get(`${ROOT_URL}/campaigns/${id}/emails${query_string}`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: FETCH_CAMPAIGN_EMAILS,
    payload: request
  };
}

export function fetchCampaignSMS(id, query_string = '') {
  const request = axios.get(`${ROOT_URL}/campaigns/${id}/sms${query_string}`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: FETCH_CAMPAIGN_SMS,
    payload: request
  };
}

export function fetchCampaignRVMs(id, query_string = '') {
  const request = axios.get(`${ROOT_URL}/campaigns/${id}/rvms${query_string}`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: FETCH_CAMPAIGN_RVMS,
    payload: request
  };
}

export function fetchCampaignPostcards(id, query_string = '') {
  const request = axios.get(`${ROOT_URL}/campaigns/${id}/postcards${query_string}`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: FETCH_CAMPAIGN_POSTCARDS,
    payload: request
  };
}

export function fetchCampaignSubscriptions(id, query_string = '') {
  const request = axios.get(`${ROOT_URL}/campaigns/${id}/subscriptions${query_string}`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: FETCH_CAMPAIGN_SUBSCRIPTIONS,
    payload: request
  };
}


// ==============================================
// Templates
// ==============================================

export function fetchTemplates(query_string = '') {
  const request = axios.get(`${ROOT_URL}/email_templates${query_string}`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: FETCH_TEMPLATES,
    payload: request
  };
}

export function createTemplate(props) {
  const request = axios.post(`${ROOT_URL}/email_templates`, props, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: CREATE_TEMPLATE,
    payload: request
  };
}

export function fetchTemplate(id) {
  const request = axios.get(`${ROOT_URL}/email_templates/${id}`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: FETCH_TEMPLATE,
    payload: request
  };
}

export function deleteTemplate(id) {
  const request = axios.delete(`${ROOT_URL}/email_templates/${id}`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: DELETE_TEMPLATE,
    payload: request
  };
}

export function duplicateTemplate(id, props) {
  const request = axios.post(`${ROOT_URL}/email_templates/${id}/duplicate`, props, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: DUPLICATE_TEMPLATE,
    payload: request
  };
}

export function updateTemplate(id, props) {
  const request = axios.put(`${ROOT_URL}/email_templates/${id}`, props, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: UPDATE_TEMPLATE,
    payload: request
  };
}

// ==============================================
// Company
// ==============================================


export function fetchCompany() {
  const request = axios.get( `${ROOT_URL}/company/show`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: FETCH_COMPANY,
    payload: request
  };
}

export function fetchRookeryStatusInfo() {
  const request = axios.get( `${ROOT_URL}/company/rookery_status_info`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: FETCH_ROOKERY_STATUS_INFO,
    payload: request
  };
}

export function postCompanyConfigure() {
  const request = axios.post(`${ROOT_URL}/company/configure`, {}, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: POST_COMPANY_CONFIGURE,
    payload: request
  };
}

export function fetchCompanyRegistrar() {
  const request = axios.get( `${ROOT_URL}/company/registrar`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: FETCH_COMPANY_REGISTRAR,
    payload: request
  };
}

export function acceptCompanyTOS() {
  const request = axios.put( `${ROOT_URL}/company/accept_tos`, {}, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: ACCEPT_COMPANY_TOS,
    payload: request
  };
}

export function acceptCompanyRVMUsage() {
  const request = axios.put( `${ROOT_URL}/company/accept_rvm_usage`, {}, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: ACCEPT_COMPANY_RVM_USAGE,
    payload: request
  };
}

export function pokeCompanyDNS(site_uuid) {
  const request = axios.post(`${ROOT_URL}/company/poke_dns`, {}, { headers: {'X-Site-UUID': site_uuid} })
    .catch(function (error) { processErrors(error); });

  return {
    type: POKE_COMPANY_DNS,
    payload: request
  };
}

export function changeCompanyIp(site_uuid, props) {
  const request = axios.post(`${ROOT_URL}/company/change_ip`,  props, { headers: {'X-Site-UUID': site_uuid} })
    .catch(function (error) { processErrors(error); });

  return {
    type: CHANGE_COMPANY_IP,
    payload: request
  };
}

export function changeCompanyDomain(site_uuid, props) {
  const request = axios.post(`${ROOT_URL}/company/change_domain`,  props, { headers: {'X-Site-UUID': site_uuid} })
    .catch(function (error) { processErrors(error); });

  return {
    type: CHANGE_COMPANY_DOMAIN,
    payload: request
  };
}

export function enableCompany(site_uuid) {
  const request = axios.post(`${ROOT_URL}/company/enable`, {}, { headers: {'X-Site-UUID': site_uuid} })
    .catch(function (error) { processErrors(error); });

  return {
    type: ENABLE_COMPANY,
    payload: request
  };
}

export function disableCompany(site_uuid) {
  const request = axios.post(`${ROOT_URL}/company/disable`, {}, { headers: {'X-Site-UUID': site_uuid} })
    .catch(function (error) { processErrors(error); });

  return {
    type: DISABLE_COMPANY,
    payload: request
  };
}

export function pokeCompanyLeadRouterRelation(site_uuid) {
  const request = axios.post(`${ROOT_URL}/company/poke_lead_router_relation`, {}, { headers: {'X-Site-UUID': site_uuid} })
    .catch(function (error) { processErrors(error); });

  return {
    type: POKE_COMPANY_LRR,
    payload: request
  };
}

export function updateCompanyOfficeHours(props) {
  const request = axios.put(`${ROOT_URL}/company/office_hours`, props, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: UPDATE_COMPANY_OFFICE_HOURS,
    payload: request
  };
}

export function updateCompanyGeekAI(props) {
  const request = axios.put(`${ROOT_URL}/company/geek_ai`, props, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: UPDATE_COMPANY_GEEK_AI,
    payload: request
  };
}



// ==============================================
// Email Broadcasts
// ==============================================

export function fetchEmailBroadcasts(query_string = '') {
  const request = axios.get(`${ROOT_URL}/eblasts${query_string}`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: FETCH_EMAIL_BROADCASTS,
    payload: request
  };
}

export function fetchEmailBroadcastEmails(id, query_string = '') {
  const request = axios.get(`${ROOT_URL}/eblasts/${id}/emails${query_string}`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: FETCH_EMAIL_BROADCAST_EMAILS,
    payload: request
  };
}

export function cancelEmailBroadcast(id) {
  const request = axios.get(`${ROOT_URL}/eblasts/${id}/cancel`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: CANCEL_EMAIL_BROADCAST,
    payload: request
  };
}

export function fetchAllEmailBroadcasts(query_string = '') {
  const request = axios.get(`${ROOT_URL}/eblasts/all${query_string}`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: FETCH_EMAIL_BROADCASTS,
    payload: request
  };
}

// ==============================================
// Template Categories
// ==============================================

export function fetchTemplateCategories(query_string = '') {
  const request = axios.get(`${ROOT_URL}/email_template_categories${query_string}`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: FETCH_TEMPLATE_CATEGORIES,
    payload: request
  };
}

export function createTemplateCategory(props) {
  const request = axios.post(`${ROOT_URL}/email_template_categories`, props, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: CREATE_TEMPLATE_CATEGORY,
    payload: request
  };
}

export function editTemplateCategory(id, props) {
  const request = axios.put(`${ROOT_URL}/email_template_categories/${id}`, props, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: EDIT_TEMPLATE_CATEGORY,
    payload: request
  };
}

// ==============================================
// Company Stuff!
// ==============================================

export function fetchCompanies(query_string = '') {
  const request = axios.get( `${ROOT_URL}/companies${query_string}`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: FETCH_COMPANIES,
    payload: request
  };
}

// ==============================================
// Test Email
// ==============================================

export function createTestEmail(props) {
  const request = axios.post(`${ROOT_URL}/test_emails`, props, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: CREATE_TEST_EMAIL,
    payload: request
  };
}

// ==============================================
// Test SMS
// ==============================================

export function createTestSMS(props) {
  const request = axios.post(`${ROOT_URL}/test_sms`, props, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: CREATE_TEST_SMS,
    payload: request
  };
}

// ==============================================
// S3 File Browser
// ==============================================

export function getS3FilebrowserDirectory() {
  const request = axios.get( `${ROOT_URL}/s3_browser/filebrowser_directory`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: GET_S3_FILEBROWSER_DIRECTORY,
    payload: request
  };
}

export function getS3Tokens(creds_url) {
  const request = axios.get( creds_url )
    .catch(function (error) { processErrors(error); });

  return {
    type: GET_S3_TOKENS,
    payload: request
  };
}

// ==============================================
// SMS Templates
// ==============================================

export function fetchSMSTemplates(query_string = '') {
  const request = axios.get(`${ROOT_URL}/sms_templates${query_string}`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: FETCH_SMS_TEMPLATES,
    payload: request
  };
}

export function createSMSTemplate(props) {
  const request = axios.post(`${ROOT_URL}/sms_templates`, props, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: CREATE_SMS_TEMPLATE,
    payload: request
  };
}

export function fetchSMSTemplate(id) {
  const request = axios.get(`${ROOT_URL}/sms_templates/${id}`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: FETCH_SMS_TEMPLATE,
    payload: request
  };
}

export function deleteSMSTemplate(id) {
  const request = axios.delete(`${ROOT_URL}/sms_templates/${id}`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: DELETE_SMS_TEMPLATE,
    payload: request
  };
}

export function duplicateSMSTemplate(id, props) {
  const request = axios.post(`${ROOT_URL}/sms_templates/${id}/duplicate`, props, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: DUPLICATE_SMS_TEMPLATE,
    payload: request
  };
}

export function updateSMSTemplate(id, props) {
  const request = axios.put(`${ROOT_URL}/sms_templates/${id}`, props, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: UPDATE_SMS_TEMPLATE,
    payload: request
  };
}

// ==============================================
// SMS Template Categories
// ==============================================

export function fetchSMSTemplateCategories(query_string = '') {
  const request = axios.get(`${ROOT_URL}/sms_template_categories${query_string}`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: FETCH_SMS_TEMPLATE_CATEGORIES,
    payload: request
  };
}

export function createSMSTemplateCategory(props) {
  const request = axios.post(`${ROOT_URL}/sms_template_categories`, props, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: CREATE_SMS_TEMPLATE_CATEGORY,
    payload: request
  };
}

export function editSMSTemplateCategory(id, props) {
  const request = axios.put(`${ROOT_URL}/sms_template_categories/${id}`, props, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: EDIT_SMS_TEMPLATE_CATEGORY,
    payload: request
  };
}

// ==============================================
// Starter Campaigns
// ==============================================

export function fetchAllStarterCampaigns(query_string = '?') {
  if (query_string == '') {
    query_string = '?';
  }
  const request = axios.get( `${ROOT_URL}/starter_campaigns${query_string}`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: FETCH_CAMPAIGNS,
    payload: request
  };
}

export function fetchActiveStarterCampaigns(query_string = '?') {
  if (query_string == '') {
    query_string = '?';
  }
  const request = axios.get( `${ROOT_URL}/starter_campaigns${query_string}&active=true`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: FETCH_CAMPAIGNS,
    payload: request
  };
}

export function createStarterCampaign(props) {
  let newProps = Object.assign(props, {starter: 'true'});
  const request = axios.post(`${ROOT_URL}/campaigns`, newProps, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: CREATE_CAMPAIGN,
    payload: request
  };
}

// ==============================================
// Email Addresses
// ==============================================

export function fetchEmailAddresses(query_string = '?') {
  if (query_string == '') {
    query_string = '?';
  }
  const request = axios.get( `${ROOT_URL}/email_addresses${query_string}`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: FETCH_EMAIL_ADDRESSES,
    payload: request
  };
}

export function markEmailAddressAsValid(id, props) {
  const request = axios.post(`${ROOT_URL}/email_addresses/${id}/mark_as_valid`, props, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: MARK_EMAIL_ADDRESS_AS_VALID,
    payload: request
  };
}


// ==============================================
// Sent Emails
// ==============================================

export function fetchSentEmails(query_string = '?') {
  if (query_string == '') {
    query_string = '?';
  }
  const request = axios.get( `${ROOT_URL}/sent_emails${query_string}`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: FETCH_SENT_EMAILS,
    payload: request
  };
}

export function fetchSentEmail(id) {
  const request = axios.get(`${ROOT_URL}/sent_emails/${id}`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: FETCH_SENT_EMAIL,
    payload: request
  };
}

// ==============================================
// Leads
// ==============================================

export function reengageLead(id) {
  const request = axios.post(`${ROOT_URL}/leads/${id}/reengage`, {}, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: REENGAGE_LEAD,
    payload: request
  };
}

// ==============================================
// Subscriptions
// ==============================================

export function restartSubscription(id, campaign_id) {
  const request = axios.post(`${ROOT_URL}/leads/${id}/restart`, {campaign_id: campaign_id}, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: RESTART_SUBSCRIPTION,
    payload: request
  };
}

// ==============================================
// RVM Templates
// ==============================================

export function fetchRVMTemplates(query_string = '') {
  const request = axios.get(`${ROOT_URL}/rvm_templates${query_string}`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: FETCH_RVM_TEMPLATES,
    payload: request
  };
}

export function createRVMTemplate(props) {
  const request = axios.post(`${ROOT_URL}/rvm_templates`, props, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: CREATE_RVM_TEMPLATE,
    payload: request
  };
}

export function fetchRVMTemplate(id) {
  const request = axios.get(`${ROOT_URL}/rvm_templates/${id}`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: FETCH_RVM_TEMPLATE,
    payload: request
  };
}

export function deleteRVMTemplate(id) {
  const request = axios.delete(`${ROOT_URL}/rvm_templates/${id}`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: DELETE_RVM_TEMPLATE,
    payload: request
  };
}

// ==============================================
// RVM Template Categories
// ==============================================

export function fetchRVMTemplateCategories(query_string = '') {
  const request = axios.get(`${ROOT_URL}/rvm_template_categories${query_string}`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: FETCH_RVM_TEMPLATE_CATEGORIES,
    payload: request
  };
}

export function createRVMTemplateCategory(props) {
  const request = axios.post(`${ROOT_URL}/rvm_template_categories`, props, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: CREATE_RVM_TEMPLATE_CATEGORY,
    payload: request
  };
}

export function editRVMTemplateCategory(id, props) {
  const request = axios.put(`${ROOT_URL}/rvm_template_categories/${id}`, props, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: EDIT_RVM_TEMPLATE_CATEGORY,
    payload: request
  };
}

export function updateRVMTemplate(id, props) {
  const request = axios.put(`${ROOT_URL}/rvm_templates/${id}`, props, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: UPDATE_RVM_TEMPLATE,
    payload: request
  };
}

export function createTestRVM(props) {
  const request = axios.post(`${ROOT_URL}/test_rvm`, props, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: CREATE_TEST_RVM,
    payload: request
  };
}

// ==============================================
// Video Templates
// ==============================================

export function fetchVideoTemplates(query_string = '') {
  const request = axios.get(`${ROOT_URL}/video_templates${query_string}`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: FETCH_VIDEO_TEMPLATES,
    payload: request
  };
}

export function createVideoTemplate(props) {
  const request = axios.post(`${ROOT_URL}/video_templates`, props, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: CREATE_VIDEO_TEMPLATE,
    payload: request
  };
}

export function fetchVideoTemplate(id) {
  const request = axios.get(`${ROOT_URL}/video_templates/${id}`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: FETCH_VIDEO_TEMPLATE,
    payload: request
  };
}

export function deleteVideoTemplate(id) {
  const request = axios.delete(`${ROOT_URL}/video_templates/${id}`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: DELETE_VIDEO_TEMPLATE,
    payload: request
  };
}

export function fetchVideoTemplateByName(name) {
  const request = axios.get(`${ROOT_URL}/video_templates/by_name/${name}`, { headers: {'X-Site-UUID': getSiteUuid()} });

  return {
    type: FETCH_VIDEO_TEMPLATE_BY_NAME,
    payload: request
  };
}

// ==============================================
// Video Template Categories
// ==============================================

export function fetchVideoTemplateCategories(query_string = '') {
  const request = axios.get(`${ROOT_URL}/video_template_categories${query_string}`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: FETCH_VIDEO_TEMPLATE_CATEGORIES,
    payload: request
  };
}

export function createVideoTemplateCategory(props) {
  const request = axios.post(`${ROOT_URL}/video_template_categories`, props, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: CREATE_VIDEO_TEMPLATE_CATEGORY,
    payload: request
  };
}

export function editVideoTemplateCategory(id, props) {
  const request = axios.put(`${ROOT_URL}/video_template_categories/${id}`, props, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: EDIT_VIDEO_TEMPLATE_CATEGORY,
    payload: request
  };
}

export function updateVideoTemplate(id, props) {
  const request = axios.put(`${ROOT_URL}/video_templates/${id}`, props, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: UPDATE_VIDEO_TEMPLATE,
    payload: request
  };
}

// ==============================================
// Leads
// ==============================================

export function fetchLeads(query_string = '') {
  const request = axios.get(`${ROOT_URL}/leads${query_string}`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: FETCH_LEADS,
    payload: request
  };
}

// ==============================================
// Lead Filter Logs
// ==============================================

export function fetchLeadFilterLogs(id, query_string = '') {
  const request = axios.get(`${ROOT_URL}/leads/${id}/filter_logs${query_string}`, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: FETCH_LEAD_FILTER_LOGS,
    payload: request
  };
}

// ==============================================
// Reactive Response Settings
// ==============================================

export function fetchReactiveResponseSettings(query_string = '') {
  const request = axios.get(`${ROOT_URL}/reactive_response_settings${query_string}`, { headers: {'X-Site-UUID':  getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type: FETCH_REACTIVE_RESPONSE_SETTINGS,
    payload: request
  };
}

export function editReactiveResponseSettings(props) {
  const request = axios.put(`${ROOT_URL}/reactive_response_settings`, props, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type:  EDIT_REACTIVE_RESPONSE_SETTINGS,
    payload: request
  };
}

export function editReactiveResponsePriority(props) {
  const request = axios.put(`${ROOT_URL}/reactive_response_settings/set_priority`, props, { headers: {'X-Site-UUID': getSiteUuid()} })
    .catch(function (error) { processErrors(error); });

  return {
    type:  EDIT_REACTIVE_RESPONSE_PRIORITIZE,
    payload: request
  };
}

